import { ComplaintsCategoriesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useComplaintsCategories = () => {
  const { data, loading, error } = useQuery(ComplaintsCategoriesDocument, {
    variables: {
      onlyEnabled: false,
    },
  })

  const categories = data?.complaints?.categoriesConnection?.nodes || []

  return {
    categories,
    loading,
    error,
  }
}
